{
  "action": "الإجراء",
  "allSides": "جميع الاتجاهات",
  "allStatus": "جميع الحالات",
  "amount": "المبلغ",
  "assetsWallet": "الأصول / المحفظة",
  "available": "المتاح",
  "availableBalance": "الرصيد المتاح",
  "baseCurrency": "العملة الأساسية",
  "buy": "شراء",
  "buyExalt": "شراء EXALT",
  "buyLong": "شراء / لونغ",
  "buySellTabs": "شراء أو بيع",
  "buyToken": "شراء العملة",
  "cancelOrder": "إلغاء الطلب",
  "cancelOrderFailed": "فشل إلغاء الأمر",
  "cancelled": "ملغي",
  "cancelledOrders": "الطلبات الملغاة",
  "change24h": "تغير 24 ساعة",
  "close": "إغلاق",
  "completed": "مكتمل",
  "confirmCancelOrder": "هل أنت متأكد أنك تريد إلغاء هذا الأمر؟",
  "connectWalletFirst": "قم بتوصيل المحفظة أولاً",
  "cost": "التكلفة",
  "deposits": "الإيداعات",
  "done": "تم",
  "enterAmount": "أدخل المبلغ",
  "enterPrice": "أدخل السعر",
  "enterValidAmount": "الرجاء إدخال مبلغ صحيح.",
  "enterValidPrice": "الرجاء إدخال سعر صحيح.",
  "exportCsv": "تصدير CSV",
  "failed": "فشل",
  "filled": "منفذ",
  "filledOrders": "الطلبات المنفذة",
  "filtered": "مُصفّى",
  "hash": "الهاش",
  "high24h": "أعلى سعر خلال 24 ساعة",
  "installWallet": "يرجى تثبيت MetaMask أو Trust Wallet",
  "instruments": "الأدوات",
  "insufficientBalance": "رصيد غير كافٍ.",
  "lastPrice": "آخر سعر",
  "limit": "محدد",
  "limitOrder": "أمر محدد",
  "limitPrice": "سعر محدد",
  "loadingOrders": "جاري تحميل الأوامر...",
  "loadingTrades": "جارٍ تحميل الصفقات...",
  "loadingTransactions": "جارٍ تحميل المعاملات...",
  "low24h": "أدنى سعر خلال 24 ساعة",
  "manageFutures": "إدارة العقود الآجلة",
  "market": "سوق",
  "marketOrder": "أمر سوق",
  "marketOrderNotice": "يتم تنفيذ أوامر السوق فورًا مقابل السيولة المتاحة حاليًا. قد يختلف سعر التنفيذ، ولن يظل الجزء غير المنفذ مفتوحًا - يتم إلغاؤه فورًا.",
  "marketPrice": "سعر السوق",
  "mobileTradingChart": "الرسم البياني للتداول على الجوال",
  "moreOptions": "خيارات إضافية",
  "noFilledOrders": "لا توجد طلبات منفذة.",
  "noOpenOrders": "لا توجد طلبات مفتوحة.",
  "noOrdersFound": "لا توجد أوامر.",
  "noTradeHistory": "لم يتم العثور على سجل تداول.",
  "noTransactionsFound": "لم يتم العثور على معاملات.",
  "officialExaltContract": "عقد EXALT الرسمي",
  "open": "مفتوح",
  "openOrders": "الأوامر المفتوحة",
  "orderBook": "دفتر الأوامر",
  "orderCancelledSuccessfully": "تم إلغاء الأمر بنجاح",
  "orderFailed": "فشل الطلب.",
  "orderHistory": "سجل الطلبات",
  "orderIdMissing": "معرّف الطلب مفقود.",
  "orderPlacedSuccessfully": "تم تقديم الطلب بنجاح.",
  "orderType": "نوع الأمر",
  "pair": "الزوج",
  "pending": "قيد الانتظار",
  "placeOrder": "تقديم الطلب",
  "placingOrder": "جارٍ تقديم الطلب...",
  "positionHistory": "سجل المراكز",
  "price": "السعر",
  "processing": "جاري المعالجة...",
  "quoteCurrency": "عملة التسعير",
  "recentTrades": "الصفقات الأخيرة",
  "searchMarket": "ابحث عن السوق...",
  "searchPair": "ابحث عن الزوج...",
  "searchPairSideStatus": "البحث عن الزوج أو الاتجاه أو الحالة...",
  "searchTransactions": "البحث في المعاملات...",
  "selectPair": "اختر الزوج",
  "sell": "بيع",
  "sellExalt": "بيع EXALT",
  "sellShort": "بيع / شورت",
  "serverError": "خطأ في الخادم.",
  "sessionExpired": "انتهت الجلسة. الرجاء تسجيل الدخول مرة أخرى.",
  "side": "النوع",
  "slPrice": "سعر وقف الخسارة",
  "spotMarkets": "أسواق التداول الفوري",
  "spotTrading": "التداول الفوري",
  "spotTradingSubtitle": "محرك تداول فوري احترافي مدعوم من EXALT Exchange",
  "status": "الحالة",
  "stopLoss": "وقف الخسارة",
  "swapToExalt": "التبديل إلى EXALT",
  "takeProfit": "جني الأرباح",
  "token": "الرمز",
  "total": "الإجمالي",
  "tpPrice": "سعر جني الأرباح",
  "tpSl": "TP/SL",
  "tradFi": "TradFi / CFD",
  "tradFiNoProvider": "لم يتم توصيل أي مزود سيولة CFD/TradFi بعد.",
  "tradFiNoProviderDescription": "هذه الوحدة هي بنية تحتية جاهزة لموفر السيولة قيد التجهيز. ستظهر أدوات الفوركس والمعادن والمؤشرات والأسهم وعقود الفروقات للعملات الرقمية هنا بمجرد توصيل مزود وسيط/سيولة حقيقي والتحقق منه.",
  "tradFiStatusUnavailable": "تعذر تحميل حالة مزود TradFi في الوقت الحالي.",
  "tradeHistory": "سجل التداول",
  "trades": "الصفقات",
  "tradingViewChart": "رسم TradingView البياني",
  "transactionHistory": "سجل المعاملات",
  "volume24h": "حجم 24 ساعة",
  "walletConnected": "تم ربط المحفظة بنجاح",
  "walletConnectionFailed": "فشل ربط المحفظة",
  "withdrawal": "سحب",
  "withdrawals": "السحوبات"
}